import { render, staticRenderFns } from "./splitOrderDistribution.vue?vue&type=template&id=88a70704&scoped=true"
import script from "./splitOrderDistribution.vue?vue&type=script&lang=js"
export * from "./splitOrderDistribution.vue?vue&type=script&lang=js"
import style0 from "./splitOrderDistribution.vue?vue&type=style&index=0&id=88a70704&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a70704",
  null
  
)

export default component.exports